module.exports = __webpack_public_path__ + "static/Endowments Institute-6be4c5194f76a193785bb10acbb7024a.jpg";